@if (eliquaFacadeService.activeComponent !== 'ListsComponent') {
  <div [ngClass]="breakpointFacadeService.size === 'XSmall' ? 'filters-bar-column' : 'filters-bar'">
    <button mat-stroked-button class="filters-button" [matMenuTriggerFor]="items">
      {{ paginatorLiterals.items$ | async }}:
      {{ paginatorFacadeService.itemsNumber$ | async }}
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #items="matMenu" xPosition="after">
      @for (item of paginatorFacadeService.itemsPerPage$ | async; track item) {
        <div mat-menu-item class="option" (click)="onItemsChange(item)">
          {{ item }}
        </div>
      }
    </mat-menu>
    @if (
      eliquaFacadeService.activeComponent !== 'LiteralsSearchComponent' &&
      eliquaFacadeService.activeComponent !== 'ImportExportLiteralsComponent'
    ) {
      <button mat-stroked-button class="filters-button" [matMenuTriggerFor]="sort">
        {{ paginatorLiterals.sortField$ | async }}:
        {{ paginatorFacadeService.selectedSortField$ | async }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    }
    <mat-menu #sort="matMenu" xPosition="after">
      @for (sortFieldOption of paginatorFacadeService.sortFieldOptions$ | async; track sortFieldOption) {
        <div mat-menu-item class="option" (click)="onSortChange($event.target)">
          {{ sortFieldOption }}
        </div>
      }
    </mat-menu>
    @if (
      eliquaFacadeService.activeComponent !== 'LiteralsSearchComponent' &&
      eliquaFacadeService.activeComponent !== 'ImportExportLiteralsComponent'
    ) {
      <button mat-stroked-button class="filters-button" [matMenuTriggerFor]="order">
        {{ paginatorLiterals.order$ | async }}:
        {{ paginatorFacadeService.selectedOrder$ | async }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    }
    <mat-menu #order="matMenu" xPosition="after">
      @for (orderFieldOption of paginatorFacadeService.orderFieldOptions$ | async; track orderFieldOption) {
        <div mat-menu-item class="option" (click)="onOrderChange($event.target)">
          {{ orderFieldOption }}
        </div>
      }
    </mat-menu>
  </div>
}

<div class="total-results">Totals results: {{ paginatorFacadeService.totalResultPages$ | async }}</div>

<div class="paginator">
  <mat-paginator
    #paginator
    [showFirstLastButtons]="true"
    [hidePageSize]="true"
    [length]="paginatorFacadeService.totalResultPages$ | async"
    [pageSize]="paginatorFacadeService.itemsNumber$ | async"
    [pageIndex]="paginatorFacadeService.pageIndex$ | async"
    (page)="pagingChanged($event)"
  >
  </mat-paginator>
</div>
